import type { BitrixCompanyModel } from "../viewModels/Dictionaries/BitrixCompanyModel";

export function uniqueCompanies(companies: ReadonlyArray<BitrixCompanyModel | undefined>): BitrixCompanyModel[] {
  const byId = new Map<number, BitrixCompanyModel>();
  companies.forEach((company) => {
    if (company && !byId.has(company.id)) byId.set(company.id, company);
  });
  return Array.from(byId.values());
}
